import React, { useEffect, useState } from 'react'
import ProfileC from '../Components/profile/ProfileC';
import DonationBalance from '../Components/profile/DonationBalance';
import RegularDonation from '../Components/profile/RegularDonation';
import Notification from '../Components/profile/Notification';
import { getUserProfile, updateUserProfile } from '../Common/apis';
import { toast } from 'react-toastify';
import Loader from '../Components/Loader/Loader';

function Profile() {
    const [sideBtn, setSideBtn] = useState("Profile");
    const [userData, setUserData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [imageLoading, setImageLoading] = useState(false);


    useEffect(() => {
        fetchUserProfile();
    }, []);

    //  Fetch User Data from API
    const fetchUserProfile = async () => {
        setLoading(true);
        try {
            const response = await getUserProfile();
            setUserData(response.data);
        } catch (error) {
            toast.error("Failed to fetch profile!");
        } finally {
            setLoading(false);
        }
    };

    //  Handle Image Upload
    const handleImageChange = async (event) => {
        const file = event.target.files[0];
        if (!file) return;

        const formData = new FormData();
        formData.append("profileImage", file);

        setImageLoading(true);
        try {
            const response = await updateUserProfile(formData);
            setUserData({ ...userData, profileImage: response.data.profileImage });
            toast.success("Profile image updated successfully!");
        } catch (error) {
            toast.error("Failed to update profile image!");
        } finally {
            setImageLoading(false);
        }
    };

    return (
        <>
            {loading && <Loader />}
            <section className="lg:pt-[50px] pt-[50px] lg:pb-[120px] pb-[50px] mt-[80px]">
                <h6 className="text-center max-w-[572px] w-full mx-auto text-heading-primary text-[#2D190D] pb-[50px]">My Profile</h6>
                <div className='xl:px-[110px] lg:px-[50px] px-[20px]'>
                    <div className="flex justify-center lg:flex-row flex-col items-start gap-[32px]">
                        <div className='lg:max-w-[271px] max-w-full pb-[40px] w-full bg-[#F6F8FA] border border-[#E7E4FC] rounded-[12px] px-[19px] py-[12px]'>
                            <div className="flex flex-col gap-[4px]">
                                <div onClick={() => setSideBtn("Profile")} className={`flex items-center gap-[6px] ${sideBtn === "Profile" ? "profile-menu-active" : "profile-menu"}`}>
                                    <img src="/assets/profile/item5.svg" alt="" />
                                    <p className="font-[500] text-[16px] font-manrope">Profile</p>
                                </div>
                                <div onClick={() => setSideBtn("Regular Donation")} className={`flex items-center gap-[6px] ${sideBtn === "Regular Donation" ? "profile-menu-active" : "profile-menu"}`}>
                                    <img src="/assets/profile/item3.svg" alt="" />
                                    <p className="font-[500] text-[16px] font-manrope">Regular Donation</p>
                                </div>
                                <div onClick={() => setSideBtn("Donation Balance")} className={`flex items-center gap-[6px] ${sideBtn === "Donation Balance" ? "profile-menu-active" : "profile-menu"}`}>
                                    <img src="/assets/profile/item7.svg" alt="" />
                                    <p className="font-[500] text-[16px] font-manrope">Donation Balance</p>
                                </div>
                                <div onClick={() => setSideBtn("Donation Reminder")} className={`flex items-center gap-[6px] ${sideBtn === "Donation Reminder" ? "profile-menu-active" : "profile-menu"}`}>
                                    <img src="/assets/profile/item1.svg" alt="" />
                                    <p className="font-[500] text-[16px] font-manrope">Donation Reminder</p>
                                </div>
                                <div onClick={() => setSideBtn("Notification")} className={`flex items-center gap-[6px] ${sideBtn === "Notification" ? "profile-menu-active" : "profile-menu"}`}>
                                    <img src="/assets/profile/item2.svg" alt="" />
                                    <p className="font-[500] text-[16px] font-manrope">Notification</p>
                                </div>
                                <div onClick={() => setSideBtn("Setting")} className={`flex items-center gap-[6px] ${sideBtn === "Setting" ? "profile-menu-active" : "profile-menu"}`}>
                                    <img src="/assets/profile/item6.svg" alt="" />
                                    <p className="font-[500] text-[16px] font-manrope">Setting</p>
                                </div>
                                <div onClick={() => setSideBtn("Log Out")} className={`flex items-center gap-[6px] ${sideBtn === "Log Out" ? "profile-menu-active" : "profile-menu"}`}>
                                    <img src="/assets/profile/item4.svg" alt="" />
                                    <p className="font-[500] text-[16px] font-manrope">Log Out</p>
                                </div>
                            </div>
                        </div>
                        <div className="max-w-[916px] w-full">
                            {sideBtn === "Profile" &&
                                <ProfileC sideClick={() => setSideBtn("Donation Balance")} userData={userData} handleImageChange={handleImageChange} setUserData={setUserData} />
                            }
                            {sideBtn === "Regular Donation" &&
                                <RegularDonation />
                            }
                            {sideBtn === "Donation Balance" &&
                                <DonationBalance wallet={userData?.Wallet} />
                            }
                            {sideBtn === "Notification" &&
                                <Notification />
                            }
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Profile